export default "__VITE_ASSET__4rSk1ofL__"